import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="scroll-mt-24 bg-[#F4F3EF] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.faq.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19]">
            {t.faq.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-8">
          <div className="border-t border-stone-300">
            {t.faq.items.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-stone-300">
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-serif text-xl md:text-2xl text-[#1A1C19]">
                      {f.q}
                    </span>
                    <span className="shrink-0 text-[#3A4036]">
                      {isOpen ? (
                        <Minus size={22} strokeWidth={1.5} />
                      ) : (
                        <Plus size={22} strokeWidth={1.5} />
                      )}
                    </span>
                  </button>
                  <div
                    data-testid={`faq-answer-${i}`}
                    className={`grid transition-all duration-500 ease-out ${
                      isOpen
                        ? "grid-rows-[1fr] opacity-100 pb-6"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <p className="overflow-hidden text-base md:text-lg leading-relaxed text-[#5C5C59] max-w-2xl">
                      {f.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
